<template>
  <div>
    <transition
      name="fade-ads"
      mode="out-in"
    >
      <img
        :key="ads[activeAd]"
        :src="'/storage/ads/small/' + ads[activeAd]"
        height="600"
        width="300"
      >
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SideAds',
  props: {
    ads: {
      type: Array,
      default() {
        return [];
      },
    },
    slideChange: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      activeAd: 0,
    };
  },
  watch: {
    slideChange() {
      this.activeAd++;
      if (this.activeAd === this.ads.length) {
        this.activeAd = 0;
      }
    },
  },
};
</script>
